export const showColor = (status: string, dateTime: Date | null): string => {
  let type = "success";
  // HOY a las 08:30
  const today830 = new Date();

  // AYER a las 08:30
  const yesterday830 = new Date(today830);
  yesterday830.setDate(today830.getDate() - 1);

  const fromDateTime = dateTime ? new Date(dateTime) : null;

  if (status === "ERROR" && fromDateTime) {
    type = "danger";
  } else if (status === "OK" && fromDateTime && fromDateTime >= yesterday830) {
    type = "warning";
  } else if (fromDateTime == null) {
    type = "sucess";
  }

  return type;
};

// export const goToSeeMore = async (entity: ImageLossAlert) => {
//   const filter: Filter = {
//     fields: {
//       "imageLossAlert.id": { operator: "equal", value: entity.id },
//     },
//   };

//   const res = await getIssueDiagnosis(undefined, undefined, filter);

//   issueDiagnosis.value =
//     res.data && res.data.length > 0 ? res.data[0] : { isManual: false, status: "UNREVIEWED" };

//   selectedIssue.value = entity;
//   dialogTableVisible.value = true;
// };
